import * as React from "react";
import { type VariantProps } from "class-variance-authority";
import { Checkbox } from "radix-ui";

import { checkboxV2IconVariants, checkboxV2Variants } from "./variants";
import { cn } from "@/libs/cn";
import { CheckIcon } from "lucide-react";

export interface CheckboxV2RootProps
  extends React.ComponentPropsWithoutRef<typeof Checkbox.Root>, VariantProps<typeof checkboxV2Variants> {}

const CheckboxV2Root = React.forwardRef<React.ElementRef<typeof Checkbox.Root>, CheckboxV2RootProps>(
  ({ className, size, variant, shape, ...props }, ref) => (
    <Checkbox.Root ref={ref} className={cn(checkboxV2Variants({ size, variant, shape }), className)} {...props}>
      <Checkbox.Indicator className="flex items-center justify-center text-current fill-current">
        {shape === "circle" ? (
          <div className={cn("rounded-full bg-current", checkboxV2IconVariants({ size }))} />
        ) : (
          <CheckIcon className={cn(checkboxV2IconVariants({ size }))} />
        )}
      </Checkbox.Indicator>
    </Checkbox.Root>
  ),
);

CheckboxV2Root.displayName = "CheckboxV2Root";

export { CheckboxV2Root };
